import { formatSaleStatus } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

export const statusNoAmount = ({ status }: SearchVehicle): string => {
    return formatSaleStatus(status) || ''
}
